<template>
  <v-app>
    <v-app-bar
      app
      color="#4B2A66"
      class="elevation-2"
      v-if="
        ['launch'].indexOf($route.name) == -1 &&
        !($route.name || '').includes('landing')
      "
    >
      <div class="d-flex align-center" style="width: 100%">
        <router-link
          to="/"
          style="text-decoration: none"
          class="d-flex justify-center"
        >
          <template v-if="$vuetify.breakpoint.mdAndUp">
            <div
              class="
                mr-3
                ml-n2
                text-h4
                pink--text
                text--darken-2
                d-flex
                justify-center
                font-weight-medium
              "
            >
              <img src="/logo-white.svg" width="150" />
            </div>
          </template>
          <template v-else>
            <div class="mr-3">
              <v-avatar><img src="@/assets/logo-eye.png" /></v-avatar>
            </div>
          </template>
        </router-link>

        <SearchField class="flex-grow-1 py-2" />

        <div
          v-if="$vuetify.breakpoint.mdAndUp"
          class="flex-shrink-1 d-flex align-center ml-3"
        >
          <template v-if="$store.state.logged">
            <v-btn color="black" icon :to="{ name: 'profile' }">
              <v-avatar><v-img src="@/assets/logo-eye.png" /></v-avatar>
            </v-btn>
            <div class="pl-2 text-subtitle-2">
              <div class="text--accent-3 justify-center white--text">
                Bem-vindo(a), {{ firstname }}!
              </div>
              <div
                class="yellow--text text--accent-2 text-decoration-underline"
              >
                {{ user.city }} - {{ user.state }}
              </div>
            </div>
          </template>

          <template v-if="!$store.state.logged">
            <v-btn color="black" icon @click.stop="loginDialog = true">
              <v-avatar><v-img src="@/assets/logo-eye.png" /></v-avatar>
            </v-btn>

            <div class="pl-2">
              <v-btn color="#4B2A66" dark x-small @click="loginDialog = true">
                Entrar
              </v-btn>
              <div
                class="
                  text-caption text-decoration-underline
                  yellow--text
                  text--accent-2
                "
              >
                Salve seus produtos favoritos
              </div>
            </div>
          </template>
        </div>

        <v-btn class="ml-2" dark icon @click.stop="menudrawer = true">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <!--<div v-if="$vuetify.breakpoint.mdAndDown && $route.name =='admin/home'">
      </div>-->
      </div>
    </v-app-bar>

    <v-main>
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </v-main>

    
    <v-snackbar
      v-model="messageSnackbar.showing"
      :color="messageSnackbar.color"
      :timeout="3000"
      min-width="0"
    >
      <span
        class="font-weight-medium"
        v-html="messageSnackbar.message"
      />
      <template #action>
        <v-btn text @click="messageSnackbar.showing = false">
          ok
        </v-btn>
      </template>
    </v-snackbar>

    <v-dialog v-model="successDialog.showing" max-width="350px">
      <v-card color="white text-center" class="py-6">
        <v-img src="@/assets/logo.png" height="80px" contain />

        <v-card-title
          class="black--text font-weight-bold pt-4 pb-2 d-block"
          style="word-break: normal"
        >
          {{ successDialog.title }}
        </v-card-title>
        <v-card-text class="font-weight-medium black--text text--lighten-1">
          {{ successDialog.message }}
        </v-card-text>
        <v-card-actions class="d-flex justify-center pt-1">
          <v-btn
            color="black"
            outlined
            class="px-8"
            @click="successDialog.showing = false"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <Footer v-if="!($route.name || '').includes('landing')" />

    <v-dialog
      v-model="loginDialog"
      :fullscreen="$vuetify.breakpoint.xs"
      class="ma-0 pa-0"
      max-width="400px"
    >
      <v-card>
        <Login @logged="loginDialog = false" />
      </v-card>
    </v-dialog>

    <Menu v-model="menudrawer" />
  </v-app>
</template>

<script>
import Vue from "vue";
const STORAGE_KEY = "searchedHistory";
import Login from "@/components/Login.vue";
import Menu from "@/components/Menu.vue";
import Footer from "@/components/Footer.vue";
import SearchField from "@/components/SearchField.vue";

export default {
  name: "App",
  components: {
    Login,
    Menu,
    Footer,
    SearchField,
  },
  data: () => ({
    supportcontact: false,
    loginDialog: false,
    menudrawer: false,
    searchQuery: "",
    searchHistoryActive: false,
    searchHistory: [],
    messageSnackbar: {
      showing: false,
      message: "",
      color: "",
    },
    successDialog: {
      showing: false,
      title: "",
      message: "",
    },
  }),
  methods: {
    showMessage(color, msg) {
      this.messageSnackbar.showing = false;
      this.$nextTick(() => {
        this.messageSnackbar.color = color;
        this.messageSnackbar.message = msg;
        this.messageSnackbar.showing = true;
      });
    },
    showSuccessMessage(title, msg) {
      this.messageSnackbar.showing = false;
      this.$nextTick(() => {
        this.successDialog.title = title;
        this.successDialog.message = msg;
        this.successDialog.showing = true;
      });
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    hideSearchHistory() {
      setTimeout(() => {
        this.searchHistoryActive = false;
      }, 100);
    },
    search(search) {
      this.$router.push({
        path: "/busca/" + search,
        params: {
          query: this.searchQuery,
        },
      });
      this.searchHistory.unshift({
        title: this.searchQuery,
        completed: "false",
        id: 1,
      });
      this.searchQuery = "";
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.searchHistory));
    },
  },
  computed: {
    filteredSearched() {
      return this.searchHistory.filter((query) => {
        return query.title.toLowerCase().match(this.searchQuery.toLowerCase());
      });
    },
    user() {
      return this.$store.state.user;
    },
    firstname() {
      return this.user.name.split(" ")[0];
    },
  },
  mounted() {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "862131384319736",
        cookie: true,
        xfbml: true,
        version: "v8.0",
      });
      window.FB.AppEvents.logPageView();
    };
  },
  created() {
    Vue.prototype.$showMessage = this.showMessage;
    Vue.prototype.$showSuccessMessage = this.showSuccessMessage;
    this.searchHistory = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    // this.$getLocation({}).then((coordinates) => {
    //   this.coordinates = coordinates;
    // });
    //.catch((error) => alert(error));
  },
};
</script>
  